import styled from 'styled-components';
import LegalTerms from '../../atoms/LegalTerms';
import { Type, spacer4, spacer16, spacer20, opacityBlack10, black, rose180, TextLink, desktopViola, white, spacer32, screenSmMin, spacer12, blue100, spacer8, desktopBallad, gray85, desktopCelloCanon, } from '@spotify-internal/encore-web';
import container from '../../atoms/Container/container';
const colorChecker = (isGPB) => (isGPB ? `${black}` : `${white}`);
export const StyledContainer = styled(container) `
  ${({ isGPB }) => isGPB
    ? `
    background: ${white}; 

    > section:first-child,
    article:first-child {
      padding-top: ${spacer32} !important;
      --container-padding-start: 0;
      --container-padding-end: ${spacer12};

      @media (min-width: ${screenSmMin}) {
        padding-bottom: ${spacer12};
      }
    }
  `
    : ''}
`;
export const CardContainer = styled.div `
  margin: 0 auto;
  max-width: 580px;
`;
export const AboveCard = styled.div `
  margin: 0 0 ${({ isGPB }) => (isGPB ? `${spacer20}` : `${spacer16}`)};
  display: flex;
  justify-content: space-between;

  ${({ isGPB }) => (!isGPB ? `font-size: ${desktopBallad};` : '')}

  color: ${({ color, isGPB }) => color && !isGPB ? color : colorChecker(isGPB)};

  [href]:hover {
    color: ${({ color, isGPB }) => color && !isGPB ? color : colorChecker(isGPB)};
  }
`;
export const Card = styled.article `
  color: ${({ color, isGPB }) => (color ? color : colorChecker(isGPB))};

  ${({ isGPB }) => isGPB
    ? `
    border-radius: ${spacer16};
    box-shadow: 0 2px 10px 0 ${opacityBlack10};
  `
    : ''}

  ${({ background, isGPB }) => background && !isGPB
    ? `background-color: ${background};
     padding: ${spacer16};
     border: 1px solid ${gray85};
     border-radius: 7px;
     box-shadow: 0 1px 1px ${opacityBlack10};
     @media (min-width: ${screenSmMin}) {
      padding: ${spacer16} ${spacer20};
     }`
    : ''};
`;
export const Promotion = styled(Type.p) `
  background-color: ${blue100};
  color: ${white};
  border-radius: 4px;
  padding: ${spacer4} ${spacer8};
  display: inline-block;
  margin-bottom: ${spacer12};
  margin-block-start: 0;
`;
export const CardHeader = styled.div `
  padding: ${spacer16};
  background: ${({ background }) => (background ? background : `${rose180}`)};
  border-top-left-radius: ${spacer16};
  border-top-right-radius: ${spacer16};
`;
export const Text = styled(Type.p) `
  margin: 0;
  padding: 0;

  ${({ isGPB }) => (!isGPB ? `font: ${desktopBallad};` : '')}
`;
export const Link = styled(TextLink) `
  font-size: ${desktopViola.fontSize};
  margin-top: auto;
`;
export const Header = styled(Type.h2) `
  margin: 0 0 ${({ isGPB }) => (isGPB ? `${spacer4}` : `${spacer8}`)};
  padding: 0;

  ${({ isGPB }) => (!isGPB ? `font: ${desktopCelloCanon};` : '')}
`;
export const LegalText = styled(LegalTerms) `
  padding: ${spacer16};

  ${({ isGPB }) => !isGPB
    ? `margin: ${spacer12} 0 0;
    padding: 0;
  `
    : ''}

  a {
    color: inherit;
    text-decoration: underline;
    font-weight: bold;
  }
`;
//# sourceMappingURL=components.js.map